import React from 'react'

import './style.scss'

const DataPrivacySwitch = ({ checked, setChecked }) => {
    return (
        <div className="dataPrivacyContainer">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <p style={{ fontWeight: 400 }}>I’d prefer not to provide this info</p>

                <span className={`resourceBookingOption`}>
                    <input
                        type="radio"
                        name="resourceBookingOption"
                        id={`resourceBookingOption`}
                        checked={checked}
                        onClick={() => setChecked(!checked)}
                        required
                    />
                    <span className={`resourceBookingOptionCustomRadio`} />
                </span>
            </div>
            <div>
                <p>Just so you know, we’ll never share personal information with your manager or company.</p>
            </div>
        </div>
    )
}

export default DataPrivacySwitch
